const css = `@charset "UTF-8";
.exercise-media-modal {
  width: 90vw;
  max-width: 800px;
}
.exercise-media-modal .p-dialog-content {
  overflow: visible !important;
  padding: 0 !important;
}
.exercise-media-modal .exercise-media-content {
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.exercise-media-modal .exercise-media-content .preview-container {
  margin: 0;
  width: 100%;
  height: auto;
  max-height: 70vh;
  min-height: 200px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface);
  /* Clase específica para contenedores de video */
  /* Para navegadores que soportan :has */
}
.exercise-media-modal .exercise-media-content .preview-container.video-container {
  aspect-ratio: 16/9;
  max-width: 800px;
  margin: 0 auto;
}
.exercise-media-modal .exercise-media-content .preview-container:has(.preview-video) {
  aspect-ratio: 16/9;
  max-width: 800px;
  margin: 0 auto;
}
.exercise-media-modal .exercise-media-content .preview-container .preview-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: black;
}
.exercise-media-modal .exercise-media-content .preview-container .preview-video:not(video) {
  border: none;
  background-color: transparent;
}
.exercise-media-modal .exercise-media-content .preview-container .preview-image {
  max-width: 100%;
  max-height: 100%;
}
.exercise-media-modal .exercise-media-content .preview-container .preview-image img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
.exercise-media-modal .exercise-media-content .no-media-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 32px;
  text-align: center;
  background: var(--surface-sunken);
  border-radius: var(--border-radius);
}
.exercise-media-modal .exercise-media-content .no-media-message i {
  font-size: var(--font-size-4xl);
  color: var(--text-muted);
}
.exercise-media-modal .exercise-media-content .no-media-message p {
  color: var(--text-muted);
  font-size: var(--font-size-base);
  margin: 0;
}

@media screen and (max-width: 768px) {
  .exercise-media-modal {
    width: 100%;
    margin: 0;
  }
  .exercise-media-modal .preview-container {
    max-height: 60vh;
    /* Mantener aspect ratio incluso en móvil */
  }
  .exercise-media-modal .preview-container.video-container, .exercise-media-modal .preview-container:has(.preview-video) {
    aspect-ratio: 16/9;
    max-width: 100%;
  }
}
/* Específico para pantallas muy pequeñas como iPhone SE */
@media screen and (max-width: 375px) {
  .exercise-media-modal .preview-container {
    max-height: 50vh;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvRXhlcmNpc2VNZWRpYU1vZGFsIiwic291cmNlcyI6WyJFeGVyY2lzZU1lZGlhTW9kYWwuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtBQUVBO0FBT0E7O0FBTkE7RUFDRTtFQUNBO0VBQ0E7O0FBSUY7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBOztBQUtOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBTVI7RUFDRTtJQUNFO0lBQ0E7O0VBRUE7SUFDRTtBQUVBOztFQUNBO0lBRUU7SUFDQTs7O0FBTVI7QUFDQTtFQUVJO0lBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhlcmNpc2UtbWVkaWEtbW9kYWwge1xuICB3aWR0aDogOTB2dztcbiAgbWF4LXdpZHRoOiA4MDBweDtcblxuICAucC1kaWFsb2ctY29udGVudCB7XG4gICAgb3ZlcmZsb3c6IHZpc2libGUgIWltcG9ydGFudDtcbiAgICBwYWRkaW5nOiAwICFpbXBvcnRhbnQ7XG4gIH1cblxuICAuZXhlcmNpc2UtbWVkaWEtY29udGVudCB7XG4gICAgcGFkZGluZzogMDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgb3ZlcmZsb3c6IHZpc2libGU7XG5cbiAgICAucHJldmlldy1jb250YWluZXIge1xuICAgICAgbWFyZ2luOiAwO1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBoZWlnaHQ6IGF1dG87XG4gICAgICBtYXgtaGVpZ2h0OiA3MHZoO1xuICAgICAgbWluLWhlaWdodDogMjAwcHg7XG4gICAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2UpO1xuXG4gICAgICAvKiBDbGFzZSBlc3BlY8OtZmljYSBwYXJhIGNvbnRlbmVkb3JlcyBkZSB2aWRlbyAqL1xuICAgICAgJi52aWRlby1jb250YWluZXIge1xuICAgICAgICBhc3BlY3QtcmF0aW86IDE2Lzk7XG4gICAgICAgIG1heC13aWR0aDogODAwcHg7XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgfVxuXG4gICAgICAvKiBQYXJhIG5hdmVnYWRvcmVzIHF1ZSBzb3BvcnRhbiA6aGFzICovXG4gICAgICAmOmhhcygucHJldmlldy12aWRlbykge1xuICAgICAgICBhc3BlY3QtcmF0aW86IDE2Lzk7XG4gICAgICAgIG1heC13aWR0aDogODAwcHg7XG4gICAgICAgIG1hcmdpbjogMCBhdXRvO1xuICAgICAgfVxuXG4gICAgICAucHJldmlldy12aWRlbyB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIG9iamVjdC1maXQ6IGNvbnRhaW47XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6IGJsYWNrO1xuXG4gICAgICAgICY6bm90KHZpZGVvKSB7XG4gICAgICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5wcmV2aWV3LWltYWdlIHtcbiAgICAgICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgICAgICBtYXgtaGVpZ2h0OiAxMDAlO1xuICAgICAgICBpbWcge1xuICAgICAgICAgIG1heC13aWR0aDogMTAwJTtcbiAgICAgICAgICBoZWlnaHQ6IGF1dG87XG4gICAgICAgICAgb2JqZWN0LWZpdDogY29udGFpbjtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgIC5uby1tZWRpYS1tZXNzYWdlIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgZ2FwOiAxNnB4O1xuICAgICAgcGFkZGluZzogNDhweCAzMnB4O1xuICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgYmFja2dyb3VuZDogdmFyKC0tc3VyZmFjZS1zdW5rZW4pO1xuICAgICAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cyk7XG5cbiAgICAgIGkge1xuICAgICAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS00eGwpO1xuICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICB9XG5cbiAgICAgIHAge1xuICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWJhc2UpO1xuICAgICAgICBtYXJnaW46IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5leGVyY2lzZS1tZWRpYS1tb2RhbCB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWFyZ2luOiAwO1xuXG4gICAgLnByZXZpZXctY29udGFpbmVyIHtcbiAgICAgIG1heC1oZWlnaHQ6IDYwdmg7XG5cbiAgICAgIC8qIE1hbnRlbmVyIGFzcGVjdCByYXRpbyBpbmNsdXNvIGVuIG3Ds3ZpbCAqL1xuICAgICAgJi52aWRlby1jb250YWluZXIsXG4gICAgICAmOmhhcygucHJldmlldy12aWRlbykge1xuICAgICAgICBhc3BlY3QtcmF0aW86IDE2Lzk7XG4gICAgICAgIG1heC13aWR0aDogMTAwJTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLyogRXNwZWPDrWZpY28gcGFyYSBwYW50YWxsYXMgbXV5IHBlcXVlw7FhcyBjb21vIGlQaG9uZSBTRSAqL1xuQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogMzc1cHgpIHtcbiAgLmV4ZXJjaXNlLW1lZGlhLW1vZGFsIHtcbiAgICAucHJldmlldy1jb250YWluZXIge1xuICAgICAgbWF4LWhlaWdodDogNTB2aDtcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
